import { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  Stack,
  IconButton,
  Button,
  InputLabel,
} from "@mui/material";
import { useLoader } from "../context/LoaderContext";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import InputFileUpload from "./InputFileUpload";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import MemberForm from "../widgets/MemberForm";
import { host } from "../constant/backendpath";
import login from "../assets/img/login.svg";
import ProfilePopup from "../widgets/ProfilePopup";
import Alert from "../widgets/AlertModal";
import Regis_closed from "../assets/img/Regis_closed.png";

const Registration = ({
  isLogged,
  setCurrent,
  chance,
  setChance,
  profileDetails,
  setProfileDetails,
  updateProfile,
}) => {
  const [teamDetails, setTeamDetails] = useState({
    TeamLead: "",
    Member1: "",
    Member2: "",
    Member3: "",
  });
  const [teamName, setTeamName] = useState("");
  const [projectTitle, setProjectTitle] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [abstractFile, setabstractFile] = useState(null);
  const [pptFile, setpptFile] = useState(null);
  const [videoFile, setvideoFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [hasExistingRegistration, setHasExistingRegistration] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("info");
  const [alertOnOk, setAlertOnOk] = useState(() => null);
  const isSmall = useMediaQuery("(max-width:733px)");
  const [access ,setAccess] = useState(false);
  const [closed, setClosed] = useState(false);
  console.log(profileDetails);

  const regex = {
    username: /^9176(?:2[3-6])(?:1[1-6])[0-3]\d{2}$/,
    teamName: /^[A-Za-z][A-Za-z0-9 ]{2,}$/,
    title: /^[A-Za-z0-9 ]+$/,
  };

  const checkProfileCompleteness = (details) => {
    const requiredFields = ['name', 'dept', 'reg_no', 'year', 'number'];
    return requiredFields.every(
      (field) => details[field] !== null && details[field] !== undefined && details[field] !== ""
    );
  }
  
  const { setLoading } = useLoader();

  const validate = () => {
    const err = {};
    if (!regex.teamName.test(teamName)) err.teamName = true;
    // if (!regex.title.test(projectTitle)) err.projectTitle = true;
    // if (projectDescription.length < 5 || projectDescription.length > 100)
    //   err.projectDescription = true;

    Object.entries(teamDetails || {}).forEach(([key, value]) => {
      if (!regex.username.test(value)) err[key] = true;
      // console.log(typeof key)
      if(!value && key !== "teamLead") delete err[key];
    });

    return err;
  };
  async function fetchRegister() {
    setLoading(true);
    try {
      const res = await axios.get(`${host}getRegister`, {
        withCredentials: true,
      });
      // console.log('==== getRegister FULL response ====', res.data);
      if (res.status === 200) {
        const { details, teamDetails, disable } = res.data;
        // console.log('Extracted details:', details);
        // console.log('Profile fields:', { name: details?.name, dept: details?.dept, reg_no: details?.reg_no, year: details?.year, number: details?.number });
        setProfileDetails(details); // ← From profile fetch

        if (teamDetails) {
          setTeamDetails({
            TeamLead: teamDetails.teamLeadRegNo,
            Member1: teamDetails.member1RegNo || '',
            Member2: teamDetails.member2RegNo || '',
            Member3: teamDetails.member3RegNo || '',
          });
          setTeamName(teamDetails.teamName);
          setSubmitted(true);
          setHasExistingRegistration(true);
          setProjectTitle(teamDetails.details.title);
          setProjectDescription(teamDetails.details.description);
          if(details.reg_no == teamDetails.teamLeadRegNo) setAccess(true);
          setChance(false); // Already in team, no need to show popup
        } else {
          setHasExistingRegistration(false);
          setAccess(true);
          setTeamDetails({TeamLead: details.reg_no});
          const isIncomplete = !checkProfileCompleteness(details);
          // cons ole.log('Registration profile incomplete:', isIncomplete, 'Details:', details);
          setChance(isIncomplete); // User not in a team → show popup if profile incomplete
        }
      }
    } catch (err) {
      // console.error(err);
      setAlertMessage("Fetch unsuccessful");
      setAlertType("error");
      setAlertOnOk(() => null);
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  }

const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitted(true);

  const validationErrors = validate();
  setErrors(validationErrors);

  if (Object.keys(validationErrors).length > 0) return;

  const formData = new FormData();

  // Append team & project details
  formData.append("teamName", teamName);
  formData.append("projectTitle", projectTitle || "");
  formData.append("projectDescription", projectDescription || "");

  // Append team members (only non-empty)
  Object.entries(teamDetails).forEach(([key, value]) => {
    if (value) {
      formData.append(`teamDetails[${key}]`, value);
    }
  });

  // Append files if they exist
  if (abstractFile) formData.append("abstract", abstractFile);
  if (pptFile) formData.append("ppt", pptFile);
  if (videoFile) formData.append("video", videoFile);

  // console.log(formData)

  setLoading(true);
  try {
    const res = await axios.post(`${host}submit`, formData, {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (res.status === 200 || res.status === 201) {
      setAlertType("success");
      setAlertMessage("Form submitted successfully");
      setHasExistingRegistration(true);
      setAlertOnOk(() => fetchRegister);
      setAlertOpen(true);
    } else {
      setAlertMessage(res.data.message || "Form submission failed");
      setAlertType("error");
      setAlertOnOk(() => null);
      setAlertOpen(true);
    }
  } catch (err) {
    // console.error("Submission error:", err.response?.data || err.message);
    setAlertMessage(err.response?.data?.message || "Form submission failed");
    setAlertType("error");
    setAlertOnOk(() => null);
    setAlertOpen(true);
  } finally {
    setLoading(false);
  }
};



  const updateTeamDetails = (field, value) =>
    setTeamDetails((prev) => ({
      ...prev,
      [field]: value,
    }));

  const resetRegistration = () => {
    setTeamName("");
    setTeamDetails({ TeamLead: "", Member1: "", Member2: "", Member3: "" });
    setProjectTitle("");
    setProjectDescription("");
    setabstractFile(null);
    setpptFile(null);
    setvideoFile(null);
    setErrors({});
    setSubmitted(false);
  };

  function handleLogin() {
    setCurrent(4);
  }
useEffect(() => {
  
  fetchRegister();
}, []);
// console.log(errors)

  return (!hasExistingRegistration && closed) ? (
<div
  style={{
    width: "100%",
    minHeight: "90vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxSizing: "border-box",
    padding: "clamp(16px, 4vw, 40px)",
    overflow: "hidden",
  }}
>
  <img
    src={Regis_closed}
    alt="Registration Closed"
    style={{
      display: "block",
      width: "min(90vw, 700px)",
      height: "auto",
      maxHeight: "80vh",
      objectFit: "contain",
    }}
  />
</div>  )
   : isLogged ? (
    <Box p={3} maxWidth="85%" margin="auto">
      {chance && (
        <ProfilePopup
          profileDetails={profileDetails}
          setProfileDetails={setProfileDetails}
          setChance={setChance}
          updateProfile={updateProfile}
          register={true}
        />
      )}
      <Alert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        type={alertType}
        onOk={alertOnOk}
      />
      <Typography variant="h5" mb={3} sx={{ fontWeight: "bold" }}>
        Project Registration Form
      </Typography>

      <Box
        component="fieldset"
        sx={{ border: "2px solid black", borderRadius: 2, p: 2, mt: 2 }}
      >
        <Box component="legend" sx={{ fontWeight: "bold", color: "black" }}>
          Team Details
        </Box>
        <TextField
          label="Team Name"
          size="small"
          margin="dense"
          value={teamName}
          onChange={(e) => setTeamName(e.target.value)}
          sx={{ width: isSmall ? "100%" : "23%" }}
          InputLabelProps={{ sx: { fontWeight: "bold" } }}
          error={submitted && errors.teamName}
        />
        <MemberForm
          data={teamDetails}
          isSmall={isSmall}
          onChange={updateTeamDetails}
          type={true}
          error={submitted ? errors : {}}
          disable ={!access}
        />
      </Box>

      <Box
        component="fieldset"
        sx={{ border: "2px solid black", borderRadius: 2, p: 2, mt: 2 }}
      >
        <Box component="legend" sx={{ fontWeight: "bold", color: "black" }}>
          Project Details
        </Box>
        <TextField
          label="Project Title"
          size="small"
          margin="dense"
          value={projectTitle}
          onChange={(e) => setProjectTitle(e.target.value)}
          sx={{ width: isSmall ? "100%" : "23%", mb: 2 }}
          InputLabelProps={{ sx: { fontWeight: "bold" } }}
          error={submitted && errors.projectTitle}
        />
        <TextField
          label="Project Description"
          size="small"
          margin="dense"
          multiline
          maxRows={4}
          fullWidth
          value={projectDescription}
          onChange={(e) => setProjectDescription(e.target.value)}
          InputLabelProps={{ sx: { fontWeight: "bold" } }}
          error={submitted && errors.projectDescription}
        />
        {/* <Box
          sx={{
            display: isSmall ? "block" : "flex",
            gap: "10px",
            mt: 2,
          }}
        >
          {[
            {
              label: "Abstract",
              icon: <InsertDriveFileIcon />,
              setter: setabstractFile,
            },
            { label: "PPT", icon: <SlideshowIcon />, setter: setpptFile },
            {
              label: "Video (if available)",
              icon: <VideoLibraryIcon />,
              setter: setvideoFile,
            },
          ].map(({ label, icon, setter }) => (
            <Box
              key={label}
              sx={{ position: "relative", mb: isSmall ? 2 : 0, flex: 1 }}
            >
              <InputLabel>{label}</InputLabel>
              <InputFileUpload setFile={setter} />
              <IconButton sx={{ position: "absolute", right: 10, top: "32%" }}>
                {icon}
              </IconButton>
            </Box>
          ))}
        </Box> */}
      </Box>

      <Stack direction="row" justifyContent="center" mt={3}>
        <Button
          variant="contained"
          color="primary"
          sx={{ borderRadius: "30px", width: "150px" }}
          onClick={(e)=>handleSubmit(e)}
          disabled={!access}
        >
          {hasExistingRegistration ? "Update" : "Register"}
        </Button>
        {hasExistingRegistration && (
          <Button
            variant="outlined"
            color="secondary"
            sx={{ borderRadius: "30px", width: "150px", ml: 2 }}
            onClick={() => window.open("https://forms.gle/xK6m7YAzCxm89AXL8", "_blank")}
          >
            Initial Form link
          </Button>
        )}
      </Stack>
    </Box>
  ) : (
    <>
      <Stack direction="row" justifyContent="center">
        <Box
          component={"img"}
          src={login}
          sx={{ width: "30%", height: "30%" }}
        ></Box>
      </Stack>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "40px",
        }}
      >
        Kindly Login and Register
      </Box>
      <Stack direction="row" justifyContent="center" mt={3}>
        <Button
          variant="contained"
          color="primary"
          sx={{ borderRadius: "30px", width: "150px" }}
          onClick={handleLogin}
        >
          Login
        </Button>
      </Stack>
    </>
  );
};

export default Registration;
